export default __webpack_public_path__ + "static/media/nikhil.18c5121f.jpg";